import { BrowserModule }         from '@angular/platform-browser';
import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';
import { UpgradeModule }         from '@angular/upgrade/static';

import { AdminDashboardModule }   from './admin-dashboard/admin-dashboard.module';
import { AppLiteModule }          from '../app-lite/app.module';
import { AssemblyPaymentsModule } from './assembly-payments/assembly-payments.module';
import { BookingsModule }         from './bookings/bookings.module';
import { CheckaModule }           from './checka/checka.module';
import { CompaniesModule }        from './companies/companies.module';
import { CustomersModule }        from './customers/customers.module';
import { DashboardModule }        from './dashboard/dashboard.module';
import { DealershipModule }       from './dealership/dealership.module';
import { EventsModule }           from './events/events.module';
import { InspectionsModule }      from './inspections/inspections.module';
import { MechanicsModule }        from './mechanics/mechanics.module';
import { PriceMatrixModule }      from './price-matrix/price-matrix.module';
import { ProductsModule }         from './products/products.module';
import { PurchaseOrdersModule }   from './purchase-orders/purchase-orders.module';
import { VehiclesModule }         from './vehicles/vehicles.module';
import { VehicleVisualsModule }   from './vehicle-visuals/vehicle-visuals.module';
import { VendorsModule }          from './vendors/vendors.module';

@NgModule({
  imports: [
    // Angular
    BrowserModule,
    UpgradeModule,

    // Third party
    UIRouterUpgradeModule.forRoot(),

    // Custom
    AdminDashboardModule,
    AppLiteModule,
    AssemblyPaymentsModule,
    BookingsModule,
    CheckaModule,
    CompaniesModule,
    CustomersModule,
    DashboardModule,
    DealershipModule,
    EventsModule,
    InspectionsModule,
    MechanicsModule,
    PriceMatrixModule,
    ProductsModule,
    PurchaseOrdersModule,
    VehiclesModule,
    VehicleVisualsModule,
    VendorsModule
  ]
})
export class AppModule {
  constructor( private upgrade: UpgradeModule ) { }

  ngDoBootstrap() {
    this.upgrade.bootstrap(document.body, ['workshop'], { strictDi: false });
  }
}
